<template>
  <b-steps
    size="is-small"
    v-model="activeStep"
    :animated="true"
    :rounded="true"
    :has-navigation="true"
    label-position="bottom"
    mobile-mode="minimalist"
  >
    <b-step-item
      class="registration"
      step="1"
      label="規約の同意"
      :clickable="false"
    >
      <QualificationConfirmation v-model="qualification" />
    </b-step-item>
    <b-step-item
      class="registration"
      step="2"
      label="メール登録"
      :clickable="false"
    >
      <EmailRegistrationForm v-model="authentication" />
    </b-step-item>
    <b-step-item
      class="registration"
      step="3"
      label="プロフィール"
      :clickable="false"
    >
      <RegistrationProfileSetting v-model="profileSetting" />
    </b-step-item>
    <b-step-item
      class="registration"
      step="4"
      label="プロフィール画像"
      :clickable="false"
    >
      <RegistrationProfileImage v-model="profileImage" />
    </b-step-item>
    <b-step-item class="registration" step="5" label="確認" :clickable="false">
      <RegistrationConfirmation :profileData="profileData" />
    </b-step-item>
    <template #navigation="{ previous, next }">
      <div class="formbuttons">
        <b-button
          v-if="activeStep != 0"
          outlined
          class="previous"
          :disabled="previous.disabled"
          @click.prevent="previous.action"
        >
          前へ
        </b-button>
        <b-button
          v-if="activeStep !== 4"
          outlined
          class="next"
          :disabled="!canGoNext"
          @click.prevent="onNextButtonClicked(next)"
        >
          次へ
        </b-button>
        <b-button
          v-if="activeStep == 4"
          outlined
          class="submit button__grad"
          :disabled="!canSubmitRegistration"
          @click="submitRegistration"
          :loading="sending"
        >
          登録
        </b-button>
      </div>
    </template>
  </b-steps>
</template>

<script>
import EmailRegistrationForm from '@/components/Organisms/UserRegistrationFlowChildren/EmailRegistrationForm';
import RegistrationProfileSetting from '@/components/Organisms/UserRegistrationFlowChildren/RegistrationProfileSetting';
import RegistrationProfileImage from '@/components/Organisms/UserRegistrationFlowChildren/RegistrationProfileImage';
import RegistrationConfirmation from '@/components/Organisms/UserRegistrationFlowChildren/RegistrationConfirmation';
import QualificationConfirmation from '@/components/Organisms/UserRegistrationFlowChildren/QualificationConfirmation';
import profileMixin from '@/mixins/profileMixin'

export default {
  name: 'UserRegistrationFlow',
  mixins: [profileMixin],
  props: {
    userType: { type: String },
  },components: {
    RegistrationProfileSetting,
    RegistrationProfileImage,
    RegistrationConfirmation,
    EmailRegistrationForm,
    QualificationConfirmation
  },
  computed: {
    canGoNext() {
      if (this.activeStep == 0) {
        return this.qualification.isValid;
      }
      if (this.activeStep == 1) {
        return this.authentication.isValid;
      }
      if (this.activeStep == 2) {
        return this.profileSetting.isValid;
      }
      return true;
    },
    canSubmitRegistration() {
      return this.qualification.isValid && this.profileSetting.isValid;
    },
    profileData() {
      let previewPhotoUrl = this.profileImage.defaultPhotoUrl;
      if (this.profileImage.photoFile) {
        previewPhotoUrl = URL.createObjectURL(this.profileImage.photoFile);
      }
      return {
        photoURL: previewPhotoUrl,
        email: this.authentication.email,
        nickname: this.profileSetting.nickname,
        birthDate: this.qualification.birthDate,
        userType: this.userType
      };
    }
  },
  data() {
    return {
      activeStep: 0,
      qualification: {
        birthDate: null, // 誕生日
        agreePolicies: false, // 規約へ同意しているかどうか
        isValid: false
      },
      authentication: {
        email: '', // メールアドレス
        password: '', // パスワード
        isValid: false
      },
      profileSetting: {
        nickname: '', // ニックネーム
        isValid: false
      },
      profileImage: {
        photoFile: null, // プロフィール画像のファイルオブジェクト
        defaultPhotoUrl: null // はじめに表示する画像のURL
      },
      sending: false
    };
  },
  methods: {
    async submitRegistration() {
      try {
        this.sending = true;
        let uid = await this.$store.dispatch('createUser', {
          email: this.authentication.email,
          password: this.authentication.password,
          photoFile: this.profileImage.photoFile,
          defaultPhotoUrl: this.profileImage.defaultPhotoUrl,
          nickname: this.profileSetting.nickname,
          birthDate: this.qualification.birthDate,
          userType: this.userType
        });

        if (this.userType === 'performer') {
          await this.$store.dispatch('createChannel', uid);
        }

        this.$router.push('/user/created');
      } catch (err) {
        if (err.code && err.code == 'auth/email-already-in-use') {
          this.$buefy.toast.open({
            duration: 3000,
            message: 'ご指定のメールアドレスは既に使用されています。',
            type: 'is-danger'
          });
        }
        if (err.code && err.code == 'auth/invalid-email') {
          this.$buefy.toast.open({
            duration: 3000,
            message: '不正なメールアドレスです。',
            type: 'is-danger'
          });
        }
        console.error(err);
        return;
      } finally {
        this.sending = false;
      }
    },
    onNextButtonClicked(next) {
      if (!this.validateActiveStep()) return;
      next.action();
    },
    validateActiveStep() {
      if (this.activeStep == 2) {
        this.nickname = this.profileSetting.nickname;
        return this.validate();
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/signup-email.scss';
</style>
